import { ICustomIconProps } from './types';

const IconAnchor: React.FC<ICustomIconProps> = ({ size = 24, color = '#ffffff' }) => (
  <svg width={size} height={size} viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.5 8C14.1569 8 15.5 6.65685 15.5 5C15.5 3.34315 14.1569 2 12.5 2C10.8431 2 9.5 3.34315 9.5 5C9.5 6.65685 10.8431 8 12.5 8Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M12.5 22V8' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M5.5 12H2.5C2.5 14.6522 3.55357 17.1957 5.42893 19.0711C7.3043 20.9464 9.84784 22 12.5 22C15.1522 22 17.6957 20.9464 19.5711 19.0711C21.4464 17.1957 22.5 14.6522 22.5 12H19.5'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconAnchor;
